import {MinLength, Length} from 'class-validator';

export class ResetPassword {
    @Length(9)
    Login: string;

    @MinLength(1)
    Poblacion: string;

    gRecaptchaResponse: string;
}
